export default [
  // 总部工具集——总部发货
  {
    path: "purChasingOrder",
    name: "purChasingOrder",
    meta: {
      title: "总部发货",
    },
    component: () => import("@/views/Home/headTools/purChasingOrder"),
  },
  // 总部工具集——小工具
  {
    path: "Toolset",
    name: "Toolset",
    meta: {
      title: "小工具"
    },
    component: () => import("@/views/Home/headTools/Toolset")
  },
  // 总部工具集——体验账号申请记录
  {
    path: "ApplicationRecord",
    name: "ApplicationRecord",
    meta: {
      title: "体验账号申请记录"
    },
    component: () => import("@/views/Home/headTools/ApplicationRecord")
  },
  // 总部工具集——总部调货记录
  {
    path: "GoodsTransferRecord",
    name: "GoodsTransferRecord",
    meta: {
      title: "总部调货记录"
    },
    component: () => import("@/views/Home/headTools/GoodsTransferRecord")
  },
  // 总部工具集——代理商账户操作
  {
    path: "AccountOperation",
    name: "AccountOperation",
    meta: {
      title: "代理商账户操作"
    },
    component: () => import("@/views/Home/headTools/AccountOperation")
  }
];
